'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var cx = require('classnames');
var react = require('react');
var useDefaultInternalState = require('../../hooks/useDefaultInternalState.js');
var SimpleInput = require('./SimpleInput.js');
var alloyInput_module = require('./alloy-input.module.scss.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var cx__default = /*#__PURE__*/_interopDefault(cx);

var isNumber = function (v) { return typeof v == 'number'; };
var NumberInput = react.forwardRef(function (_a, ref) {
    var _b = _a.type, type = _b === void 0 ? 'number' : _b, _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.value, value = _d === void 0 ? '' : _d, setValue = _a.setValue, min = _a.min, max = _a.max, _e = _a.withDecimals, withDecimals = _e === void 0 ? false : _e, onBlur = _a.onBlur, onFocus = _a.onFocus, onChange = _a.onChange, onKeyDown = _a.onKeyDown, error = _a.error, setError = _a.setError, validator = _a.validator, inputProps = tslib.__rest(_a, ["type", "className", "value", "setValue", "min", "max", "withDecimals", "onBlur", "onFocus", "onChange", "onKeyDown", "error", "setError", "validator"]);
    var _f = useDefaultInternalState.default(value, setValue), valueState = _f[0], setValueState = _f[1];
    var _g = useDefaultInternalState.default(error, setError), errorState = _g[0], setErrorState = _g[1];
    var handleFocus = function (e) {
        setErrorState(null);
        if (onFocus) {
            onFocus(e);
        }
    };
    var handleBlur = function (e) {
        if (validator) {
            var result = validator(valueState);
            setErrorState(result);
        }
        else {
            setErrorState(null);
        }
        if (onBlur) {
            onBlur(e);
        }
    };
    var handleKeyDown = function (e) {
        var _a, _b;
        var isKeyNumber = /[0-9]/g.test(e.key);
        // IE handle Decimal and Subtract keys
        var isDecimalPoint = e.key === '.' || e.key === 'Decimal';
        var isNegativeSign = e.key === '-' || e.key === 'Subtract';
        var isSpecialKey = e.key.length > 1 && !isNegativeSign && !isDecimalPoint;
        //We want to let the user to copy/paste
        var isCopingOrPasting = (((_a = e.key) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'c' || ((_b = e.key) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === 'v') &&
            e.ctrlKey;
        var preventDecimal = !withDecimals;
        var preventNegativeSign = isNumber(min) && min >= 0;
        if (!isKeyNumber &&
            !(isDecimalPoint && !preventDecimal) &&
            !(isNegativeSign && !preventNegativeSign) &&
            !isCopingOrPasting &&
            !isSpecialKey) {
            e.preventDefault();
        }
        if (onKeyDown) {
            onKeyDown(e);
        }
    };
    var handleChange = function (e) {
        var _a = e.target, value = _a.value, validity = _a.validity;
        if (isNaN(Number(value)) || (validity === null || validity === void 0 ? void 0 : validity.badInput)) {
            return;
        }
        if (value !== '') {
            var newVal = withDecimals ? parseFloat(value) : parseInt(value, 10);
            if (!(isNumber(min) && newVal < min) &&
                !(isNumber(max) && newVal > max)) {
                setValueState(newVal);
                if (onChange) {
                    onChange(e);
                }
            }
        }
        else {
            setValueState(value);
            if (onChange) {
                onChange(e);
            }
        }
    };
    return (jsxRuntime.jsx(SimpleInput.default, tslib.__assign({ ref: ref, className: cx__default.default(alloyInput_module.default['input-number'], className), type: type, value: valueState, onBlur: handleBlur, onFocus: handleFocus, onChange: handleChange, onKeyDown: handleKeyDown, error: errorState, min: min, max: max }, inputProps)));
});
NumberInput.displayName = 'NumberInput';
var NumberInput$1 = NumberInput;

exports.default = NumberInput$1;
//# sourceMappingURL=NumberInput.js.map
